module.exports = require("core-js/library/fn/object/set-prototype-of");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/object/set-prototype-of"
// module id = 13
// module chunks = 0